import classNames from 'classnames';
import {observer} from 'mobx-react';
import React from 'react';
import {ReactNodeGenerator} from '../../../../../../lib/helpers';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {McqModel} from '../../models';
import {SingleSelectMcqStore} from '../SingleSelectMcqStore';

interface Props {
  id: number,
  model: McqModel,
  store: X9ContentStateStore,
  lessonType?: string
}

function* renderer(store: SingleSelectMcqStore, lessonType?: string): ReactNodeGenerator {
  if (store.model.behavior !== 'single-select')
    return;
  if (store.state === null)
    return;

  const model = store.model;
  const state = store.state;
  const choices = model.choices;
  const selectedIndex = state.selectedIndex;
  const checked = state.checked;
  const correct = checked && selectedIndex !== null && choices[selectedIndex].selected;
  const incorrect = checked && selectedIndex !== null && !(choices[selectedIndex].selected);
  const isExam = lessonType === 'Examination';

  for (let index = 0; index < model.choices.length; index++) {
    let choice = model.choices[index];

    const selected = state.selectedIndex === index;
    const classname = classNames('mcq single-select', {
      selected: selected,
      checked: !isExam && selected && checked,
      correct: !isExam && selected && correct,
      incorrect: !isExam && selected && incorrect
    });
    yield (
      <div className="row" key={index}>
        <div className="col">
          <div className={classname}>
            <div className="form-group">
              <div className="form-check">
                <label className="form-check-label">
                  <input type="radio" className="form-check-input"
                         checked={selected}
                         onChange={() => store.select(index)}
                         disabled={!isExam && correct}/>
                  {choice.label}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!isExam) {
    yield (
      <div className="row justify-content-end" key="check">
        <div className="col-auto">
          <button className="btn btn-primary" type="button" onClick={store.check}
                  disabled={correct}> Check
          </button>
        </div>
      </div>);
  }
}

@observer
export class StudentSingleSelectMcq extends React.Component<Props> {
  readonly store: SingleSelectMcqStore;

  constructor(props: Readonly<Props>) {
    super(props);
    this.store = new SingleSelectMcqStore(props.id, props.model, props.store);
  }

  render() {
    return Array.from(renderer(this.store, this.props.lessonType));
  }
}
